import { useSelector } from 'react-redux';

import { hasConnectedPaymentProviderSelector, isProvidersLoadedSelector } from '@/domain/paySettings/selectors';

import { hasNonDisconnectedPaymentProviderSelector } from '@/domain/paySettings/selectorForPermissions';
import { hasAnyPermissionsForCompanyPayModuleSelector } from '@/domain/env/envSelector';

interface UserScreenFlow {
  showSubscribeScreen: boolean;
  showRequestAccessScreen: boolean;
  showWorkspace: boolean;
}

const useUserScreenFlow = (): UserScreenFlow => {
  const hasNonDisconnectedPaymentProvider = useSelector(hasNonDisconnectedPaymentProviderSelector);
  const hasConnectedPaymentProvider = useSelector(hasConnectedPaymentProviderSelector);
  const hasAnyPermissionsForCompanyPayModule = useSelector(hasAnyPermissionsForCompanyPayModuleSelector);
  const isProvidersLoaded = useSelector(isProvidersLoadedSelector);

  const showSubscribeScreen = !hasNonDisconnectedPaymentProvider && isProvidersLoaded;
  const showRequestAccessScreen = hasConnectedPaymentProvider && !hasAnyPermissionsForCompanyPayModule;

  return {
    showSubscribeScreen,
    showRequestAccessScreen,
    showWorkspace: !showSubscribeScreen && !showRequestAccessScreen && isProvidersLoaded,
  };
};

export default useUserScreenFlow;
